import { getApiHost, getWsHost } from '../../endpoints';

// export const DEV_API_URL =  `https://npasimulcastadminapistage.npauctions.com` ;// `http://devstage-vm:8885`;
// export const DEV_WS_URL = `https://npasimulcastadminapistage.npauctions.com`;
export const ENDPOINT_TYPE = {
  WebSocket: 'ws',
  Api: 'api',
};
export const DEV_API_URL = getApiHost(); // `http://devstage-vm:8885`;
export const DEV_WS_URL = getWsHost();

export const SIMADMIN_HUB_ENDPOINT = `/SimulcastAdminHub`;

export const DEV_WS_HUB_ENDPOINT = `${DEV_WS_URL}${SIMADMIN_HUB_ENDPOINT}`;
export const DEV_API_HUB_ENDPOINT = `${DEV_API_URL}${SIMADMIN_HUB_ENDPOINT}`;

export const API_AUTH_LOGIN_ENDPOINT = '/api/Authentication/Login';

///End points for Admin API Auction Lane, product, registeredmember, transcript report

export const API_GET_STREAMERS_ENDPOINT = `${getApiHost()}/api/Streamer/GetStreamers`;
export const API_SWITCH_AUCTION_STREAMERS_ENDPOINT = `${getApiHost()}/api/EngineAdmin/SwitchAuctionStreamer`;

// do not write a unit test for this endpoint. If we do wish to, then have Robert mock a response
export const API_REBOOT_STREAMER_ENDPOINT = `${getApiHost()}/api/Streamer/Reboot`;
export const API_SWITCH_LANE_STREAMERS_ENDPOINT = `${getApiHost()}/api/EngineAdmin/SwitchLaneStreamer`;
export const API_RESET_ENGINE_CACHE_ENDPOINT = `${getApiHost()}/api/EngineAdmin/ResetEngineCache`;
export const API_RESET_AUCTION_ENDPOINT = `${getApiHost()}/api/EngineAdmin/ResetAuction`;
export const API_RELOAD_AUCTION_ENDPOINT = `${getApiHost()}/api/EngineAdmin/ReloadAuction`;
export const API_RESET_LANE_ENDPOINT = `${getApiHost()}/api/EngineAdmin/ResetLane`;
export const API_SEND_SYSTEM_MESSAGE_ENDPOINT = `${getApiHost()}/api/EngineAdmin/SendSystemMessage`;

export const API_AUCTIONS_GET_ENDPOINT = `${getApiHost()}/api/Auction/GetPagedAuctions`;
export const API_LANES_GET_ENDPOINT = `${getApiHost()}/api/Lane/GetLanesByFilters`;
export const API_REGISTEREDBIDDERS_GET_ENDPOINT = `${getApiHost()}/api/Bidder/GetPagedRegisteredBidder`;
export const API_REGISTEREDBIDDER_UPDATE_ENDPOINT = `${getApiHost()}/api/Bidder/EnableOrDisableBidder`;

export const API_PRODUCTS_GET_BYAUCTION_ENDPOINT = `${getApiHost()}/api/Product/GetPagedProductsByAuction`;
export const API_PRODUCTS_GET_BYLANE_ENDPOINT = `${getApiHost()}/api/Product/GetPagedProductsByLane`;
export const API_PRODUCT_GET_ENDPOINT = '/api/Product/GetProductDetailsByID';
export const API_PRODUCT_UPDATE_ENDPOINT = '/api/Product/UpdateProduct';
export const API_PRODUCTIMAGES_GET_BYAUCTION_ENDPOINT = `${getApiHost()}/api/ProductMediaGallery/GetPagedProductMediaGalleryByAuction`;
export const API_PRODUCTIMAGES_GET_BYLANE_ENDPOINT = `${getApiHost()}/api/ProductMediaGallery/GetPagedProductMediaGalleryByLane`;
export const API_PRODUCTIMAGES_REUPLOAD_ENDPOINT = `${getApiHost()}/api/ProductMediaGallery/ReUpload`;

export const API_AUCTION_GET_TRANSCRIPTREPORT_ENDPOINT = `${getApiHost()}/api/Auction/GetPagedTranscriptHistory`;
export const API_DASHBOARD_GET_AUCTIONS_ENDPOINT =
  '/api/DashBoard/AuctionReport';
export const API_PROXYBID_GET_BYAUCTION_ENDPOINT = `${getApiHost()}/api/Proxybid/ReadByAuction`;
export const API_PROXYBID_UPDATE_ENDPOINT = `${getApiHost()}/api/ProxyBid/Update`;
export const API_PROXYBID_DELETE_ENDPOINT = `${getApiHost()}/api/ProxyBid/Delete`;

///
export const API_MEMBERS_GET_ENDPOINT = `${getApiHost()}/api/Bidder/GetPagedRegisteredMembers`;
export const API_UNIQUEMEMBERS_GET_ENDPOINT = `${getApiHost()}/api/Bidder/GetPagedUniqueRegisteredMembers`;

export const SOCKET_ERR_MSG = `A host is required to establish a socket connection`;

export const LCLSTRG_AUCTIONID_SUFFIX = `_auctionId`;
export const LCLSTRG_LANEID_SUFFIX = `_auctionLaneId`;

export const SLEEP_MS = {
  ms: 1000,
};
export const ROUTES = {
  login: '/login',
  dashboard: '/dashboard',
  lanes: '/lanes',
  settings: '/settings',
};

export const sessionTokenKey = 'simulcastadmin_session';

//https://stackoverflow.com/questions/19304157/getting-the-reason-why-websockets-closed-with-close-code-1006
//https://datatracker.ietf.org/doc/html/rfc6455#section-7.4.1
export const connectionClosedAbnormallyCode = 1006;
export const connectionTerminatedByServerCode = 1011;
export const socketErrorCodes = [
  connectionClosedAbnormallyCode,
  connectionTerminatedByServerCode,
];
